<template src="./FormIndexes.html"></template>
<style src="./FormIndexes.scss" lang="scss"></style>
<script>
export default {
    name: 'FormIndexes',

    computed: {
        index () {
            return this.$store.state.form.index
        },

        titles () {
            return this.$store.state.strings.titles
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/FormIndexes/FormIndexes.vue